import React from "react";

import { DEFAULT_ERASER_SIZE, DEFAULT_PEN_SIZE } from "../constants";

// Owns the active drawing tool and the per-tool brush sizes. Consumed by
// DrawingToolbar (selection + size sliders) and DrawingArea (cursor +
// hover circle). The values flow into useDrawing in App as plain args —
// useDrawing stays a pure hook, not a context consumer.
const ToolContext = React.createContext(null);

export function ToolProvider({ children }) {
  const [tool, setTool] = React.useState("pen");
  const [penSize, setPenSize] = React.useState(DEFAULT_PEN_SIZE);
  const [eraserSize, setEraserSize] = React.useState(DEFAULT_ERASER_SIZE);

  const size = tool === "eraser" ? eraserSize : penSize;
  const setSize = React.useCallback(
    (next) => {
      if (tool === "eraser") setEraserSize(next);
      else setPenSize(next);
    },
    [tool],
  );

  const value = React.useMemo(
    () => ({
      tool,
      setTool,
      penSize,
      eraserSize,
      size,
      setSize,
    }),
    [tool, penSize, eraserSize, size, setSize],
  );

  return <ToolContext.Provider value={value}>{children}</ToolContext.Provider>;
}

export function useTool() {
  const ctx = React.useContext(ToolContext);
  if (!ctx) throw new Error("useTool must be used inside ToolProvider");
  return ctx;
}
